import {doApi} from "./core";

export function getRestaurantInfo(language, params) {
    return doApi(language, params, "/restaurant/get_restaurant_info");
}

export function getMixedInfo(language, params) {
    return doApi(language, params, "/restaurant/get_mixed_info");
}

export function getFidelityCard(language, params) {
    return doApi(language, params, "/restaurant/get_fidelity_card")
}

export function getNews(language, params) {
    return doApi(language, params, "/restaurant/get_news")
}

export function getStatus(language, params) {
    return doApi(language, params, "/restaurant/get_status")
}

export function getPrivacyCheckboxes(language, params) {
    return doApi(language, params, "/restaurant/get-privacy-checkboxes")
}

export function getCategoriesList(language, params) {
    return doApi(language, params, "/restaurant/get_categories_list");
}

export function getProductsList(language, params) {
    return doApi(language, params, "/restaurant/get_products_list");
}

export function getProductsListByFilter(language, params) {
    return doApi(language, params, "/restaurant/get_products_list_by_filter");
}

export function getProduct(language, params) {
    return doApi(language, params, "/restaurant/get_product");
}
